module.exports = function() {
  return new Worker(__webpack_public_path__ + "59e15b8a0364ba184a09.worker.js");
};